
import { axios, BaseApiUrl ,BaseUrl} from '../axios_config';


export const getDepartmentList = params => {
    return axios.get(`${BaseApiUrl}/ProductionReport/GetDepartment`, { params: params });
};

export function GetDeliverGoodProductionTypeList(params) {
    return axios.post(`${BaseApiUrl}/Util/GetDeliverGoodProductionTypeList`, params);
}

export function GetDeliverGoodProductionReport(params) {
    return axios.post(`${BaseApiUrl}/ProductionReport/GetDeliverGoodProductionReport`, params);
}

export function ExportDeliverGoodProductionReport(params) {
    return axios.post(`${BaseApiUrl}/ProductionReport/ExportDeliverGoodProductionReport`, params);
}